import { Empty as AntdEmpty } from "antd";

interface Props {
    message: string;
}

const EmptyMessage = ({ message }: Props) => {
    return (
        <AntdEmpty
            imageStyle={{ height: "50%"}}
            image={AntdEmpty.PRESENTED_IMAGE_DEFAULT}
            description={<span>{message}</span>}
        />
    );
};

export default EmptyMessage;
